import { logger } from '@vista-digital/occ-domain';
import { SeatPickerActionType } from './action-type';
export const seatPickerActionReducer = (state, action) => {
    switch (action.type) {
        case SeatPickerActionType.SetValidationErrorsAction: {
            const { violatedRules } = action;
            return Object.assign(Object.assign({}, state), { validationErrorMessages: violatedRules.map(rule => rule.message) });
        }
        default: {
            logger.error(`Unknown SeatPickerAction ${action.type}.`);
            return state;
        }
    }
};
//# sourceMappingURL=action-reducer.js.map